module.exports = __webpack_public_path__ + "img/radiohead.d48a05c8.jpg";